module.exports = __webpack_public_path__ + "img/66.3454649a.jpg";